import React from 'react'
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { addPost, addPostImage } from '../actions/postActions';
export const colors = {
    main: "rgb(86 ,167, 75 , 0.82)",
  };
  
  export const sizes = {
    big: "30px",
    normal: "20px",
    small: "15px",
  };
export default function AddBlog({edit}) {
    const [title, setTitle] = React.useState(edit ? post.post.title : "");
    const [body, setBody] = React.useState(edit ? post.post.content : "");
    const [image, setImage] = React.useState("");
    const [error, setError] = React.useState("");
    const dispatch = useDispatch()
    const post = useSelector(state => state.addPostReducer)
    React.useEffect(()=>{
        console.log(post)
    },[post])
    const fileUpload = React.useRef(null)
    const onSubmit = () => {
        const imageData = new FormData()
        imageData.set("image" , image)
        console.log(imageData)
        dispatch(addPost({title,body,imageData}))
        console.log(imageData,post.loading )
    }
    return (
        <Container>
          {post.loading ? (
            <div>LOADING.....</div>
          ) : (
            <>
              <div className="title">
                <div className="write--title">
                  <h2>Write A Title :</h2>
                  <input
                    type="text"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    className="text--input"
                    placeholder="Write Title.."
                  />
                </div>
              </div>
              <div className="img--upload">
                <h2>Choose The Picture To Upload : </h2>
                <input
                  type="file"
                  className="inputfile"
                  id="embedpollfileinput"
                  onChange={(e) => setImage(e.target.files[0])}
                  ref={fileUpload}
                />
                <button
                  className="img--upload__button"
                  onClick={() => fileUpload.current.click()}
                >
                  Upload Picture
                  {!image.name ? (
                    <i className="fa-solid fa-upload"></i>
                  ) : (
                    <i className="fa fa-check" aria-hidden="true"></i>
                  )}
                </button>
              </div>
              <h2>Write Content Of The Post :</h2>
              <div className="text--md--instructions">
                <div dir="rtl">
                  Write Headers Like :
                </div>
                <blockquote className="tr_bq"># Header 1</blockquote>
                <div dir="rtl">ويمكنك كتابة باقى العناوين كالتالى:</div>
    
                <blockquote className="tr_bq">
                  ## Header 2<br />
                  ### Header 3<br />
                  #### Header 4<br />
                  ##### Header 5<br />
                  ###### Header 6
                </blockquote>
              </div>
              <div className="text--editor">
                <textarea
                  rows={20}
                  placeholder="Write The Content...."
                  value={body}
                  onChange={(e) => setBody(e.target.value)}
                ></textarea>
              </div>
              {error && (
                <div className="ui negative message error-message">{error}</div>
              )}
              <h2>
                <button className="img--upload__button" onClick={onSubmit} disabled={!title && !body && !image}>
                  Submit
                </button>
              </h2>
            </>
          )}
        </Container>
      );
    };
    
    const Container = styled.div`
      .tr_bq {
        padding: 0.6rem;
        margin: 20px 0;
        direction: ltr;
        background: #eee;
        border-radius: 0.4rem;
        font-size: ${sizes.normal};
      }
      .text--editor {
        direction: ltr;
        textarea {
          width: 100%;
          border: 2px solid rgba(0, 0, 0, 0.05);
          border-radius: 5px;
          resize: none;
          padding: 40px 10px;
          font-size: ${sizes.normal};
          font-family: inherit;
          direction: ltr;
          outline: 0;
          &:focus {
            border: 2px solid rgba(0, 0, 0, 0.05);
          }
        }
      }
      .inputfile {
        display: none;
      }
      direction: ltr;
      .text--input {
        border-radius: 5px;
        font-family: inherit;
        font-size: ${sizes.normal};
        width: 100%;
        outline: none;
        border: 0;
        border: 2px solid rgba(0, 0, 0, 0.05);
        padding: 10px;
      }
      h2 {
        margin: 50px 0 20px;
      }
      .img--input {
        border: 0;
        outline: 0;
      }
      .img--upload__button {
        font-family: inherit;
        outline: 0;
        border: 0;
        background-color: ${colors.main};
        padding: 10px 10px;
        color: white;
        border-radius: 5px;
        font-size: ${sizes.normal};
      }
    `;